import { BaseQuestionnaire } from 'features/generalQuestionnaire/generalPolicy/actions';

export const useGetInitialAnswers = (
  policyQuestionnaire: BaseQuestionnaire
): Record<string, unknown> => ({
  ...(policyQuestionnaire?.answers?.personalInfo || {}),
  ...(policyQuestionnaire?.answers?.tariffInfo || {}),
});
